module.exports = __webpack_public_path__ + "img/solutions-banner.fb1f394e.jpg";